import {initTooltips} from './V3/Services/Tooltip.js';
import axios from 'axios';
import Swal from 'sweetalert2';
import escape from 'lodash/escape';
import clp from "@/_clp.js";
import {Modal} from 'bootstrap';
import dayjs from "dayjs";
import {toUpper} from "lodash/string";
import $ from 'jquery';

const customfn = (function() {
    var hookCallback;
    var postingRequests  = [];

    // Show or hide the regus staff
    $(document).on('click', 'a.show-all', function(ev){
        ev.preventDefault();

        var grid = $(this).closest('.show-all-grid');
        grid.find('.hideable').toggle('slow');

        if( $(this).find('i.fa').hasClass('fa-arrow-down')){
            $(this).find('.updowntext').text($(this).data('show-less-text'));
            $(this).find('i.fa').removeClass('fa-arrow-down').addClass('fa-arrow-up');
        }
        else{
            $(this).find('.updowntext').text($(this).data('show-more-text'));
            $(this).find('i.fa').removeClass('fa-arrow-up').addClass('fa-arrow-down');
        }

    })

    function utils_hooks__hooks() {
        return hookCallback.apply(null, arguments);
    }

    function closeSearch($form) {
        $form.find('input').val('').blur();
        $form.closest('.search-form-mask').removeClass('open').addClass('closing');
        setTimeout(function () {
            $form.closest('.search-form-mask').addClass('closed').removeClass('closing')
        }, 300);
    }

    function hideModals() {
        var modals = $('#modal-wrapper .modal');
        modals.each(function() {
            const modalInstance = Modal.getInstance(this);
            if (modalInstance) {
                modalInstance.hide();
            }
        });
    }

    function showModal(data, options) {
        if (typeof data.html !== 'undefined') {
            var modal = $(data.html).find('.modal');
            if (modal.length) {
                hideModals();
                $('#modal-wrapper').append(modal);

                setTimeout(() => {
                    modal.find("select.chosen-select").chosen({no_results_text: "Oops, nothing found!", width: '100%'}).addClass("replaced");
                }, 300);

                if(typeof options == 'undefined'){
                    var options = {};
                }
                options.show = true;

                const modalInstance = new Modal(modal, options);
                modalInstance.show();
                return true;
            }
            return false;
        }
    }

    async function getModal(url, button, options, callback) {
        setButtonLoadingStateForSelector('#modal-wrapper .modal button[data-loading-text]');

        try {
            const response = await axios.get(url);
            const data = response.data;

            if (showModal(data, options) !== true) {
                hideModals();
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong. Please try again later.',
                customClass: {
                    confirmButton: 'btn btn-light',
                }
            });
        } finally {
            if (typeof button !== "undefined") {
                resetButtonLoadingState(button);
            }
            if (typeof callback !== "undefined") {
                callback();
            }
        }
    }

    async function postModal(url, formFields, options, callback) {
        if (Array.isArray(formFields) && formFields.every(i => 'name' in i && 'value' in i)) {
            formFields = Object.fromEntries(formFields.map(({name, value}) => [name, value]));
        }

        setButtonLoadingStateForSelector('#modal-wrapper .modal button[data-loading-text]');

        if(typeof postingRequests [url] !== "undefined") {
            postingRequests [url].cancel();
        }

        const cancelTokenSource = axios.CancelToken.source();
        postingRequests [url] = cancelTokenSource;

        try {
            const response = await axios.post(url, formFields, {
                cancelToken: cancelTokenSource.token
            });

            const data = response.data;

            if (showModal(data, options) !== true) {
                hideModals();
            }

            if (typeof callback !== "undefined") {
                callback(data);
            }
        } catch (error) {
            if (!axios.isCancel(error)) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something went wrong. Please try again later.',
                    customClass: {
                        confirmButton: 'btn btn-light',
                    }
                });
                if (typeof callback !== "undefined") {
                    callback(error.response?.data);
                }
            }
        }
    }

    function typeAhead($that) {
        $that.typeahead({
            items: 4,
            minLength: 2,
            source: function (search, callback) {
                $.getJSON($that.data('source'), {'search': search}, function (items) {
                    return callback(items);
                });
            }
        });
    }

    function searchEmployeetypeAhead($that) {
        $that.typeahead({
            items: 10,
            minLength: 3,
            source: function (search, callback) {
                $.getJSON($that.data('source'), {'search': search}, function (items) {
                    if(!Array.isArray(items)) {
                        return;
                    }
                    // Find the same results in newly selected results
                    items = items.filter(function(el) {
                        return ($('#already_selected').find('input[name="employee_id[' + el.id + ']"]').length < 1);
                    });
                    return callback(items);
                });
            },
            afterSelect: function(item){
                // Let's add the selected user to the the list
                // First get the data to clone and fill in the values
                var clone = $(document).find('.hidden-employee').clone();

                if ($('#already_selected').find('input[name="employee_id[' + item.id + ']"]').length < 1) {
                    clone.find('.hidden_employee_id').val(item.id).attr('name', 'employee_id[' + item.id + ']');
                    clone.find('.delete_select_employee').data('employee-id', item.id);
                    clone.find('.employee_name').text(item.name_to_show);

                    // Append the clone
                    $(document).find('#already_selected').append(clone.html());
                }
                // Clear the searchbox.
                $(document).find('#search_employee_text').val('').blur();

                // hide the message
                $(document).find('.no_employees_selected').hide();

                // Show the already selected
                $(document).find('#already_selected').show();

            }
        });
    }

    // Set input fields and selects to readonly and disabled
    function doReadOnly(object, showOrHide, fieldClasses) {
        if (typeof fieldClasses != 'undefined') {
            object.find('input:not(' + fieldClasses + ')').attr('readonly', showOrHide).prop('readonly', showOrHide).prop('disabled', showOrHide);
            object.find('select:not(' + fieldClasses + ')').attr('disabled', showOrHide).prop('disabled', showOrHide);
        }
        else {
            object.find('input').attr('readonly', showOrHide).prop('readonly', showOrHide).prop('disabled', showOrHide);
            object.find('select').attr('disabled', showOrHide).prop('disabled', showOrHide);
        }

    }

    // Set input fields and selects to readonly and disabled
    function doReadOnlyLocks(object, rowIndex, showOrHide, type, fieldClasses, isStandaloneCheckboxChecked) {
        if(type == 'nontitan'){
            object.closest('tr').find('select[name="inventory_type"]').attr('readonly', showOrHide).prop('readonly', showOrHide);
        }

        // Set the other fields

        if (typeof fieldClasses != 'undefined') {
            object.prev().find('div.clonediv:eq(' + rowIndex + ') input:not(' + fieldClasses + ')').attr('readonly', showOrHide).prop('readonly', showOrHide);
            object.prev().find('div.clonediv:eq(' + rowIndex + ') select:not(' + fieldClasses + ')').attr('disabled', showOrHide).prop('disabled', showOrHide);
            object.prev().prev().find('div.clonediv:eq(' + rowIndex + ') input:not(' + fieldClasses + ')').attr('readonly', showOrHide).prop('readonly', showOrHide);
            object.prev().prev().find('div.clonediv:eq(' + rowIndex + ') select:not(' + fieldClasses + ')').attr('disabled', showOrHide).prop('disabled', showOrHide);
        }
        else {
            object.prev().find('div.clonediv:eq(' + rowIndex + ') input').attr('readonly', showOrHide).prop('readonly', showOrHide);
            object.prev().find('div.clonediv:eq(' + rowIndex + ') select').attr('disabled', showOrHide).prop('disabled', showOrHide);
            object.prev().prev().find('div.clonediv:eq(' + rowIndex + ') input').attr('readonly', showOrHide).prop('readonly', showOrHide);
            object.prev().prev().find('div.clonediv:eq(' + rowIndex + ') select').attr('disabled', showOrHide).prop('disabled', showOrHide);
        }

        // keep standalone checkbox and attach_to dropdown disabled for standalone lock
        if (typeof isStandaloneCheckboxChecked != 'undefined' && isStandaloneCheckboxChecked === true) {
            object.prev().prev().find('input[name="standalone[]"]:eq(' + rowIndex + ')').attr('disabled', true).prop('disabled', true);
            object.prev().find('div.clonediv:eq(' + rowIndex + ') select').attr('disabled', true).prop('disabled', true);
        }
    }

    // Clone a give row.
    // Also unset the errors, values  etc. of that row
    function cloneRow(objectToClone, key) {
        var $clonedTr = objectToClone.clone();


        if ($clonedTr.attr('id')) {
            var newId = $clonedTr.attr('id');
            newId = newId.split('-');
            newId.pop();
            newId = newId.join('-');
            newId += Math.random();
            $clonedTr.attr('id', newId)
        }

        // Remove all +1 "cloned-div"
        $clonedTr.find('td').each(function(index, el){
           if($(el).find('.clonediv').length > 1) {
               $(el).find('.clonediv:not(:last)').remove();
           }
        });
        $clonedTr.find('.both-visible').removeClass('both-visible');
        $clonedTr.find('.lock-mac-clone-holder .clonediv .form-group:not(:first)').hide();

        // set all values, readonly etc to the default start
        $clonedTr.find('input').val('').attr('readonly', false).prop('readonly', false).attr('disabled', false).prop('disabled', false);
        $clonedTr.find('select').val('0').attr('disabled', false).prop('disabled', false);
        $clonedTr.find('input,select').removeClass('is-invalid');
        $clonedTr.find('.form-group p.invalid-feedback').html('').hide();
        $clonedTr.find('.check-icon').remove();
        $clonedTr.find('.form-group .spinner').hide();
        $clonedTr.find('.form-group .btn').show();
        $clonedTr.find('[data-loading-text]').html($clonedTr.find('[data-loading-text]').data('check-text'));
        $clonedTr.find('[data-loading-text]').removeClass('disabled').removeAttr('disabled').prop('disabled', false);
        $clonedTr.find('.unregister_lock_nontitan').attr('href', '');

        $clonedTr.find('[data-lock-id]').data('lock-id', '').removeAttr('data-lock-id', '');
        $clonedTr.find('.detach-lock').attr('href', '').hide();
        $clonedTr.find('.unregister_lock_nontitan').attr('href', '');

        if(key == 'non_titan'){
            // Also clean op the id's
            $clonedTr.find('div.inventory_id_column').text('');
            // unique id for standalone checkbox so clicking on label works correctly
            let standaloneCheckboxId = 'standalone-' + newId;
            $clonedTr.find('input[type=checkbox][name="standalone[]"]').val('').attr('disabled', false).prop('disabled', false);
            $clonedTr.find('input[type=checkbox][name="standalone[]"]').val('').attr('checked', false).prop('checked', false);
            $clonedTr.find('input[type=checkbox][name="standalone[]"]').attr('id', standaloneCheckboxId);
            $clonedTr.find('input[type=checkbox][name="standalone[]"]').next('label').attr('for', standaloneCheckboxId);
            let wallReaderCheckboxId = 'wall_reader-' + newId;
            $clonedTr.find('input[name="wall_reader[]"]').val('').attr('disabled', false).prop('disabled', false).removeClass('d-none');
            $clonedTr.find('input[name="wall_reader[]"]').next('label').removeClass('d-none');
            $clonedTr.find('input[name="wall_reader[]"').attr('id', wallReaderCheckboxId);
            $clonedTr.find('input[name="wall_reader[]"').next('label').attr('for', wallReaderCheckboxId);
        }

        if(key == 'repeater'){
            // Grab the device list
            addRepeaterToDropdownNew($clonedTr.find('select'))
        }

        // Reset chosen-selects
        $clonedTr.find('.chosen-container').remove();
        $clonedTr.find('.chosen-select').val("").chosen({no_results_text: "Oops, nothing found!", width: '100%'}).addClass("replaced");;
        $clonedTr.find('.chosen-select').trigger("chosen:updated");

        // Add the type ahead function to the new location
        typeAhead($clonedTr.find('input.typeahead'));

        // Add the cloned Tr to the table
        objectToClone.closest('table').append($clonedTr);

    }

    // Register an item, with a specific url
    function registerItem($selectedTr, url, keySingular, thisButton, callback){
        var returnValue =  true;
        var self = this;
        var cols = $selectedTr.closest('form').find('thead th').length;

        if(typeof callback == "undefined") callback = function(){};

        // Remove error message if any
        $selectedTr.next().find('td.error-row').parent().remove();

        // Get the formfields and add the csrf-token
        var formFields = $selectedTr.find('input, select').serializeArray();
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});

        // Remove the is-invalid class
        $selectedTr.find('.form-group').find('input, select').removeClass('is-invalid');

        // Hide the button
        $selectedTr.find('td.' + keySingular + '_status .btn').hide();

        // Set the spinner to visible
        $selectedTr.find('td.' + keySingular + '_status .spinner').show();

        // Set the input to readonly
        doReadOnly($selectedTr, true);

        // And set the next button to loading
        var button = $(document).find('button[data-loading-text]');
        setButtonLoadingState(button);
        setButtonLoadingState(thisButton);

        $.post(url, $.param(formFields), function (data) {
            // Hide the spinner
            $selectedTr.find('td.' + keySingular + '_status .spinner').hide();

            if (data.errors) {
                for (var key in data.errors) {
                    const $input = $selectedTr.find('input[name="' + key + '"], select[name="' + key + '"]');
                    $input.addClass('is-invalid');
                    $input.closest('div.form-group').find('p.invalid-feedback').html(data.errors[key]).show();
                }

                if (data.errors.main_error) {
                    // Set the main error
                    // This message needs to be front-ended.
                    $selectedTr.after('<tr><td colspan="' + cols + '" class="error-row"><div class="form-group"><p class="invalid-feedback">'
                        + data.errors.main_error + '</p></div></td>')
                }

                if (data.clp_id) {
                    doReadOnly($selectedTr, false, '.readonly-field');
                } else {
                    doReadOnly($selectedTr, false);
                }

                // Re-show the button
                $selectedTr.find('td.' + keySingular + '_status .btn').show();
                returnValue = false;
            }

            if (data.status) {
                if (data.status == -1) {
                    // Reset the readonly
                    doReadOnly($selectedTr, false);
                    // Re-show the button
                    $selectedTr.find('td.' + keySingular + '_status .btn').show();
                }
                else {
                    if (data.clp_id) {
                        $selectedTr.find('input[name="clp_' + keySingular + '_id"]').val(data.clp_id);

                        if(data.id){
                            $selectedTr.find('input[name="aca_' + keySingular + '_id"]').val(data.id);
                        }

                        // Update the attachto field.
                        // Get the new values
                        if ($selectedTr.find('select').length > 0)
                            addRepeaterToDropdown('repeater_attach_to');

                        doReadOnly($selectedTr, false, '.readonly-field');

                        // Set row to "saved" so we can re-enable the button on change of some fields
                        $selectedTr.find('input.old_data').remove();
                        var rowData = [];
                        $selectedTr.find('input[type="text"]:not(.readonly-field), select option:selected').each(function (i, el) {
                            rowData.push($(el).val());
                        });
                        var oldData = escape(JSON.stringify(rowData));
                        $selectedTr.find('input[name="clp_' + keySingular + '_id"]').after('<input type="hidden" class="old_data" value="' + oldData + '">');

                        var icon = '';

                        if (data.online) {
                            icon = self.getSignalStrengthIcon("none");
                            if (data.signal_strength) {
                                icon = self.getSignalStrengthIcon(data.signal_strength);
                            }
                        }

                        // Set the strength
                        if (data.online) {
                            $selectedTr.find('.iq_status .invalid-feedback')
                                .html('<span class="fa fa-check text-success"/>' + icon)
                                .show();
                        } else {
                            $selectedTr.find('.iq_status .invalid-feedback')
                                .html('<span class="fa fa-remove text-danger"/>' + icon)
                                .show();
                        }

                        // TODO should be in an element with valid-feedback class
                        $selectedTr.find('.repeater_status .invalid-feedback')
                            .html('<span class="fa fa-check text-success"/>')
                            .show();

                        $selectedTr.find('td.' + keySingular + '_status .btn').hide();
                    }
                    else {
                        doReadOnly($selectedTr);
                        returnValue = false;
                    }
                }
            }
            resetButtonLoadingState(button);
            resetButtonLoadingState(thisButton);

            // Hide the button
            // $selectedTr.find('td.' + keySingular + '_status .btn').show();
        })
        .fail(function(jqXHR) {

            // Hide the spinner
            $selectedTr.find('td.' + keySingular + '_status .spinner').hide();

            if (jqXHR.responseJSON) {
                var data = jqXHR.responseJSON;
                if (data.errors) {

                    for (var key in data.errors) {
                        const $input = $selectedTr.find('input[name="' + key + '"], select[name="' + key + '"]');
                        $input.addClass('is-invalid');
                        $input.closest('div.form-group').find('p.invalid-feedback').html(data.errors[key]).show();
                    }

                    if (data.errors.main_error) {
                        // Set the main error
                        // This message needs to be front-ended.
                        $selectedTr.after('<tr><td colspan="' + cols + '" class="error-row"><div class="form-group"><p class="invalid-feedback">'
                            + data.errors.main_error + '</p></div></td>')
                    }

                    if (data.clp_id) {
                        doReadOnly($selectedTr, false, '.readonly-field');
                    } else {
                        doReadOnly($selectedTr, false);
                    }

                    // Re-show the button
                    $selectedTr.find('td.' + keySingular + '_status .btn').show();
                    returnValue = false;
                }
            }
            resetButtonLoadingState(button);
            resetButtonLoadingState(thisButton);
        })
        .always(callback);
        return returnValue;
    }

    // Post the items and go to the next step.
    function postRegisterItems($form, keyPlural, keySingular) {
        $form.find('.form-group').find('.is-invalid').removeClass('is-invalid');
        // Get all tr rows and do the checks
        // All fields must be resadonly and the clp_iq_id must be set.
        // When this is correct submit.
        var $allTr = $(document).find('table.register_' + keyPlural + ' tr.' + keySingular + '-row');
        var errors = false;

        // First trigger all buttons

        $.each($allTr, function (index, el) {
            if ($(el).find('input[name=clp_' + keySingular + '_id]').val() == "") {
                var inputs = $(el).find('input[type="text"], select');
                var errorRow = false;
                var errorRowCheck = false;
                var errorRows = [];

                $.each(inputs, function (index, inputElement) {
                    if ($(inputElement).val() == '' || ($(inputElement).prop("tagName") == "SELECT" && $(inputElement).val() == "0")) {
                        errorRow = true;
                        $(inputElement).addClass('error');
                    }
                    else {
                        errorRowCheck = true;
                    }
                })
                if (errorRow && errorRowCheck) {
                    errors = true;
                    $(el).find('input.error').removeClass('error').closest('input,select').addClass('is-invalid');
                }
                else {
                    $(el).find('input.error').removeClass('error')
                }
            }
        });

        if (errors == true) {
            var submitButton = $form.find('button[data-loading-text]');
            setTimeout(function () {
                resetButtonLoadingState(submitButton);
            }, 800)

            // Do not submit
            return false;
        }
        return true;
    }

    function checkForChangeOldata(row){
        if(row.find('input.old_data').length > 0) {
            var rowData = [];
            row.find('input[type="text"]:not(.readonly-field), select option:selected').each(function (i, el) {
                rowData.push($(el).val());
            });

            var newData = escape(JSON.stringify(rowData));

            // Check if row is dirty. If so: show button to re-check
            var statusCol = row.find('td[class*=_status]');
            if(newData != row.find('input.old_data').val() && newData != escape(row.find('input.old_data').val())) {
                statusCol.find('.spinner').hide();
                statusCol.find('.invalid-feedback').hide();
                statusCol.find('.btn').show();
            } else {
                statusCol.find('.spinner').hide();
                statusCol.find('.invalid-feedback').show();
                statusCol.find('.btn').hide();
            }
        }
    }

    // Add an extra item to the list of repeaters
    function addRepeaterToDropdown(name) {
        $.get('/centre/deviceList', function (data) {
            if (data.devices) {
                $.each(data.devices, function (index, devices) {
                    if(index != 'all') {

                        // Find the select
                        var $selectField = $(document).find('input[name="aca_repeater_id"][value="'+ index +'"]').closest('td').prev().find('select');
                        if($selectField.length) {
                            // Get the selects and the selected value.
                            // Then replace the values and add the selected values again
                            var selectedValue = $selectField.val();

                            $selectField.find('option:gt(0)').remove();
                            $.each(devices, function (dataKey, dataElement) {
                                $selectField.append('<option value="' + dataKey + '">' + dataElement + '</option>');
                                $selectField.val(selectedValue);
                            });
                        }
                    }
                });
            }
        });
    }

    function addRepeaterToDropdownNew($select) {
        $.get('/centre/deviceListAll', function (data) {
            if (data.devices) {
                $select.find('option:gt(0)').remove();
                $.each(data.devices, function (dataKey, dataElement) {
                    $select.append('<option value="' + dataKey + '">' + dataElement + '</option>');
                });
            }
        });
    }

    function getSignalStrengthIcon(strength) {
        return '<div class="wifi-symbol ' + strength + '">' +
            '<div class="wifi-circle first"></div>' +
            '<div class="wifi-circle second"></div>' +
            '<div class="wifi-circle third"></div>' +
            '<div class="wifi-circle fourth"></div>' +
        '</div>';
    }

    function placeErrorAfterItem(elements, type, error, signal) {
        if (typeof signal === "undefined") {
            signal = false;
        }

        $.each(elements, function (index, id) {
            var $el = $('span[data-clp="status"][data-type="' + type + '"][data-value="' + id + '"]');
            var parentRow = $el.closest('tr');
            var cols = parentRow.closest('table').find('thead th').length;
            var inset = $el.attr('data-error-inset') ? $el.data('error-inset') : 0;

            // Remove existing error message if any
            parentRow.next().find('td.error-row').parent().remove();

            // Add new error message - could not be found in CLP

            if (inset > 0) {
                var colspan = cols - inset;
                parentRow.after('<tr><td colspan="' + inset + '">&nbsp;</td><td colspan="' + colspan + '" class="error-row"><div class="form-group"><p class="invalid-feedback">' + error + '</p></div></td>')
            } else {
                parentRow.after('<tr><td colspan="' + cols + '" class="error-row"><div class="form-group"><p class="invalid-feedback">' + error + '</p></div></td>')
            }

            // Set no connection status error
            var status_icon = '<span class="fa fa-remove text-danger"></span>';

            // Add wifi signal icon
            if (signal) {
                status_icon += getSignalStrengthIcon('none');
            }
            if (type === 'tag') {
                status_icon += ' ' + error;
            }

            $el.after(status_icon);
            $el.parent().find('.spinner').hide();
            $el.hide();
        });
    }

    /**
     * Register locks - Start
     */
    function unsetErrorsClasses($selectedTd, type) {
        if (type === 'nontitan') {
            // type: the select for type is a custom dropdown that can't be easily styled so not removing is-invalid here
            $selectedTd.prev().prev().prev().prev().prev().find('p.invalid-feedback').html('').hide();
            // name
            $selectedTd.prev().prev().prev().prev().find(':input').removeClass('is-invalid').find('p.invalid-feedback').html('').hide();
        }

        // location
        $selectedTd.prev().prev().prev().find(':input').removeClass('is-invalid').find('p.invalid-feedback').html('').hide();
        // lock mac
        $selectedTd.prev().prev().find(':input').removeClass('is-invalid').next('p.invalid-feedback').html('').hide();
        // lock attach to
        $selectedTd.prev().find('select').removeClass('is-invalid');
        $selectedTd.prev().find('p.invalid-feedback').html('').hide();
    }

    function setErrors(data, $selectedTd, rowIndex, type) {
        let isStandaloneCheckboxChecked = false

        if (data.errors) {
            // remember if standalone checkbox was disabled in case of errors
            if ($selectedTd.closest('tr').find('input[name="standalone[]"]:eq(' + rowIndex + ')').is(':checked')) {
                isStandaloneCheckboxChecked = true;
            }

            $.each(data.errors, function(key, value){
                if (type === 'nontitan') {
                    // type: the select for type is a custom dropdown that can't be easily styled so not setting is-invalid here
                    $selectedTd.prev().prev().prev().prev().prev().find('input[name="' + key + '"],select[name="' + key + '"]').closest('div.form-group').find('p.invalid-feedback').html(data.errors[key]).show();
                    // name
                    $selectedTd.prev().prev().prev().prev().find('input[name="' + key + '"]').addClass('is-invalid');
                    $selectedTd.prev().prev().prev().prev().find('input[name="' + key + '"]').closest('div.form-group').find('p.invalid-feedback').html(value[0]).show();
                }

                // location
                $selectedTd.prev().prev().prev().find('input[name="' + key + '"]').addClass('is-invalid');
                $selectedTd.prev().prev().prev().find('input[name="' + key + '"]').closest('div.form-group').find('p.invalid-feedback').html(value[0]).show();
                // lock mac & lock name
                $selectedTd.prev().prev().find('.clonediv:eq(' + rowIndex + ')').find('input[name="' + key + '[]"]').addClass('is-invalid');
                $selectedTd.prev().prev().find('.clonediv:eq(' + rowIndex + ')').find('input[name="' + key + '[]"]').closest('div.form-group').find('p.invalid-feedback').html(value[0]).show();
                // lock attach to
                $selectedTd.prev().find('.clonediv:eq(' + rowIndex + ')').find('select[name="' + key + '[]"]').addClass('is-invalid');
                $selectedTd.prev().find('.clonediv:eq(' + rowIndex + ')').find('select[name="' + key + '[]"]').closest('div.form-group').find('p.invalid-feedback').html(value[0]).show();
            });

            if (data.errors.text && data.errors.url) {
                let div = document.createElement('div');
                div.classList.add('sub-grid-buttons', 'float-end', 'error-button');
                let a = document.createElement('a');
                a.classList.add('get-modal', 'btn', 'btn-light');
                a.setAttribute('href', data.errors.url);
                a.setAttribute('type', 'button');
                a.setAttribute('data-loading-text', 'Loading....');
                a.innerHTML = data.errors.text;
                div.append(a);
                $selectedTd.closest('tr').find('td[class*="_status"]').prev().find('.clonediv:eq(' + rowIndex + ')').find('.invalid-feedback').append(div).show();
            } else if (data.errors.main_error) {
                $selectedTd.closest('tr').find('td[class*="_status"]').prev().find('.clonediv:eq(' + rowIndex + ')').find('.invalid-feedback').unwrap('div.e-wrap').wrap('<div class="e-wrap"></div>').text(data.errors.main_error).show();
            }
        }

        if (data.clp_id) {
            doReadOnlyLocks($selectedTd, rowIndex, false, type, '.readonly-field');
        } else {
            doReadOnlyLocks($selectedTd, rowIndex, false, type, undefined, isStandaloneCheckboxChecked);
        }
    }

    function afterRegistration($selectedTd, data, rowIndex, type){
        if (data.status) {
            if (data.status == -1) {
                // Reset the readonly
                doReadOnlyLocks($selectedTd, rowIndex, false, type);
            }
            else {
                let isStandaloneCheckboxChecked = false

                // if the standalone checkbox was set, keep the attach-to dropdown disabled
                if ($selectedTd.closest('tr').find('input[name="standalone[]"]:eq(' + rowIndex + ')').is(':checked')) {
                    isStandaloneCheckboxChecked = true;
                }

                var detachButton = $selectedTd.closest('tr').find('.clonediv:eq(' + rowIndex + ')').find('button.detach-lock'),
                    removeButton = $selectedTd.closest('tr').find('.unregister_lock_nontitan');
                if (data.clp_id) {
                    $selectedTd.prev().find('.clonediv:eq(' + rowIndex + ')').find('input[name="clp_lock_id[]"]').val(data.clp_id);
                    doReadOnlyLocks($selectedTd, rowIndex, false, type, '.readonly-field', isStandaloneCheckboxChecked);
                    // TODO should be in valid-feedback block
                    $selectedTd.find('.clonediv:eq(' + rowIndex + ') .invalid-feedback')
                        .html('<span class="fa fa-check text-success"/>')
                        .show();

                    if (data.detach_url && (detachButton.attr('href') == '' || typeof detachButton.attr('href') == 'undefined')) {
                        detachButton.attr('href', data.detach_url);
                        detachButton.show();
                    }

                    // if (data.remove_url) {
                    //     removeButton.attr('href', data.remove_url);
                    //     removeButton.show();
                    // }


                    $selectedTd.find('.clonediv:eq(' + rowIndex + ') .btn').hide();
                }
                else {
                    doReadOnlyLocks($selectedTd, rowIndex, false, type);
                }

                if(data.inventory_id){
                    $selectedTd.closest('tr').find('input[name="inventory_id"]').val(data.inventory_id);
                    $selectedTd.closest('tr').find('td .inventory_id_column').text(data.inventory_id);
                }

                if(data.lock_id) {
                    $selectedTd.prev().prev().find('.clonediv:eq(' + rowIndex + ')').data('lock-id', data.lock_id).attr('data-lock-id', data.lock_id);
                }

                $selectedTd.closest('tr').find('input[name="wall_reader[]"]')?.next('label').addClass('d-none');
                $selectedTd.closest('tr').find('input[name="wall_reader[]"]')?.prop('disabled', true).addClass('d-none');
            }
        }
    }

    /**
     * Register locks - End
     */

    /**
     * Send tree start
     */
    async function sendTree() {
        var url = '/centre/hardware_review_send_tree';
        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});

        // Remove the button of the page
        var sendTreeButton = $('a.send_tree.link');
        sendTreeButton.hide();

        $(document).find('.whoops_message').remove();

        try {
            const response = await axios.post(url, $.param(formFields));
            const data = response.data;

            if (data.status && data.status == 1) {
                // Show the next button
                $('#modal-wrapper i.fa').removeClass('fa-spin');
                $('#modal-wrapper button.next-step-commissioning').trigger('click');
            }
        } catch (error) {
            hideModals();
            resetButtonLoadingState(sendTreeButton);
            sendTreeButton.show();

            let message = '';
            if (error.response && error.response.data) {
                const data = error.response.data;
                if (data.Message) {
                    message = '<br />' + data.Message;
                }
            }

            $('#centre_hardware_review').before(
                '<div class="row whoops_message"><div class="col-md-7"><div class="alert alert-info">' +
                '   <span class="fa fa-location-arrow"></span>Something went wrong while saving the system tree, please try again' + message + '</div></div></div>');
        }
    }

    /**
     * Send tree end
     */

    /**
     * Get releasing errors - Start
     */
    function getReleaseErrors(){
        var url = $('#release_error_link').val();
        var formFields = [];
        // Remove the button of the page
        $('a.release_centre_check.link').each(function() {
            resetButtonLoadingState(this);
            $(this).hide();
        });
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});

        postModal(url, formFields,{keyboard: false, backdrop: 'static'});

    }
    /**
     * Set releasing errors - End
     */

    function checkForFilledTags() {
        var filled = false;

        $('#centre_employees table tr').each(function(i, el){
            var ip = $(el).find('input[name="clp_tag_id"]');
            if(ip.val() != "") filled = true;
        });

        if(filled) {
            customfn.setButtonText($('#centre_employees .next-step-commissioning'), 'next');
        } else {
            customfn.setButtonText($('#centre_employees .next-step-commissioning'), 'skip');
        }
    }

    /**
     * AssignTags - Start
     */

    // Register the tag. But do not attach it to the customer.
    // That is done when the user clicks on save.
    function registerTag($field){
        // Set the button to loading
        var okButton = $(document).find('.assign-tags-to-company button[data-loading-text]');
        setButtonLoadingState(okButton)

        // Set the spinner
        $field.next('span.spinner').show();
        // Hide the help block
        $('.assign-tags-to-company').find('.invalid-feedback').hide();
        $('.assign-tags-to-company').find('input[name="tag_number"]').removeClass('is-invalid');
        var tag_number = $field.val();
        var url = $field.data('company-assign-tag-url');

        if(checkRegisteringTags(tag_number)){
            return false;
        }
        addRegisteringTags(tag_number);

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "tag_number", value: $(document).find('input[name="tag_number"]').val()});

        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            cache: false,
            success : function(data){
                // check for status
                // If all is ok, then clear the text field
                // Unset the spinner
                // Stop the spinner
                $field.next('span.spinner').hide();

                $('.assign-tags-to-company').find('input[name="tag_number"]').removeClass('is-invalid');

                if(data.status && data.row){
                    // Append the row to the inputs
                    $(document).find('.assigned-tags-list').append(data.row);
                    $field.val('');
                    $('a.unassign-all-tags').show();
                }

            },
            error : function(jqXHR){
                // Set an error

                $field.next('span.spinner').hide();

                //if(isset errors man) show the error
                if (jqXHR.responseJSON) {
                    var data = jqXHR.responseJSON;
                    if (data.errors.main_error) {
                        $('.assign-tags-to-company').find('input[name="tag_number"]').addClass('is-invalid');
                        $('.assign-tags-to-company').find('.invalid-feedback').text(data.errors.main_error).show();
                    }
                    // Set row to "saved" so we can re-enable the button on change of some fields
                    $(document).find('form#assign_tag_number').find('input.old_data').remove();
                    var rowData = [];
                    $(document).find('form#assign_tag_number').find('input[type="text"]').each(function (i, el) {
                        rowData.push($(el).val());
                    });
                    var oldData = escape(JSON.stringify(rowData));
                    $(document).find('form#assign_tag_number').append('<input type="hidden" class="old_data" value="' + oldData + '">');

                }
            },
        }).always(function() {
            // Remove the tag_number from the registeringTags
            removeRegisteringTags(tag_number);
            resetButtonLoadingState(okButton);
        });
    }

    // unasign the tag from the customer
    function unAssignTag($row){
        // Set the button to loading
        var okButton = $(document).find('.assign-tags-to-company button[data-loading-text]');
        setButtonLoadingState(okButton);

        var url = $row.find('a.unassign-tag').attr('href');

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "tag_id", value: $row.find('input.assigned_tag').val()});

        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            cache: false,
            success : function(data){
                if(data.status == 1){
                    // Slowly remove this row
                    $row.hide('slow', function(){ $row.remove(); });
                }
                if(typeof data.count != 'undefined'){

                    $(document).find('.assigned-tags-count').text(data.count);

                    if(data.count == 0){
                        $('a.unassign-all-tags').hide();
                        $(document).find('.assigned-tags-count-wrapper').hide();
                    }
                    else{
                        $(document).find('.assigned-tags-count-wrapper').show();
                    }
                }

                if(data.row){
                    // replace the row
                    $row.replaceWith(data.row);
                }
            },
            error : function(jqXHR){

            }
        }).always(function() {
            resetButtonLoadingState(okButton);
        });
    }

    // Register the tag and get theresponse of the server and at the returned html to the modal
    function registerBatchTag($field){
        // Set the spinner
        $field.next('span.spinner').show();
        // Hide the help block
        $field.next().next().hide();

        $field.closest('form').find('input,select').removeClass('is-invalid');
        $field.closest('form').find('.invalid-feedback').hide();

        var tag_number = $field.val();
        var url = $field.data('user-assign-tag-url');

        // Check if the tag is in the assignment proces
        if(checkRegisteringTags(tag_number)){
            return false;
        }
        addRegisteringTags(tag_number);

        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "tag_number", value: $field.val()});

        var $closestWrapper = $field.closest('.user-tag-view');
        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            cache: false,
            success : function(data){
                if(data.row){
                    $closestWrapper.html(data.row);
                    // Check if the own field mut be selected
                    if($closestWrapper.find('input.tag-input').length){
                        $closestWrapper.find('input.tag-input').focus().click();
                    }
                    else if($closestWrapper.next().next().length &&
                        $closestWrapper.next().next().find('input.tag-input').length){
                        $closestWrapper.next().next().find('input.tag-input').focus().click();
                    }
                }
            },
            error : function(jqXHR){
                //if(isset errors man) show the error
                if (jqXHR.responseJSON) {
                    var data = jqXHR.responseJSON;
                    if (data.row) {
                        $closestWrapper.html(data.row);
                        $closestWrapper.find('input.tag-input').focus().click();
                    }
                }
            },
        }).always(function() {
            // Remove the tag from the array
            removeRegisteringTags(tag_number);

            // Add the returned html
            $field.next('span.spinner').hide();
        });
    }

    function unassignBatchTag($clickedLink){
        // Get the url
        var url = $clickedLink.attr('href');

        // Unset all errors etc;
        $clickedLink.closest('form').find('input[name="tag_number"]').removeClass('is-invalid');
        $clickedLink.closest('form').find('.invalid-feedback').hide();

        // Show spinner
        $clickedLink.next('span.spinner').show();
        $clickedLink.next().next().hide();

        // Form fields
        var formFields = [];
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        formFields.push({name: "tag_id", value: $clickedLink.prev('.hidden_tag_id').val()});

        var $closestWrapper = $clickedLink.closest('.user-tag-view');
        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            cache: false,
            success : function(data){
                if (data.row) {
                    $closestWrapper.html(data.row);
                    if($closestWrapper.find('input.tag-input').length){
                        $closestWrapper.find('input.tag-input').focus().click();
                    }
                }
            },
            error : function(jqXHR){
                //if(isset errors man) show the error
                if (jqXHR.responseJSON) {
                    var data = jqXHR.responseJSON;
                    if (data.row) {
                        $closestWrapper.html(data.row);
                        if($closestWrapper.find('input.tag-input').length){
                            $closestWrapper.find('input.tag-input').focus().click();
                        }
                    }
                }
            },
        }).always(function() {
            $clickedLink.next('span.spinner').hide();
        });
    }

    /**
     * AssignTags - End
     */

    /**
     * Assign access - Start
     */

    function edit_company_access($clickedButton, key){
        // Change the text
        $clickedButton.text($clickedButton.data('text-save'));
        // Set another class
        $clickedButton.removeClass($clickedButton.data('edit-class'));
        $clickedButton.addClass($clickedButton.data('save-class'));

        var $form = $clickedButton.closest('div.datagrid-wrapper').find('form#access-edit');

        // Set the checkboxes to undisabled
        $form.find('input.has-access').removeAttr('disabled').prop('disabled', false).next('label').removeClass('disabled');

        // Show the cancle nutton
        $clickedButton.closest('div[data-type="buttons"]').find('button[class*=-edit-item-cancel]').show();
    }

    function saveAccess($clickedButton, key){
        // Hide the error
        var errorField = $('.main_error');
        errorField.hide();
        // Hide the cancel button
        var $cancelButton = $clickedButton.closest('div[data-type="buttons"]').find('button.' + key +'-access-edit-item-cancel');
        $cancelButton.hide();

        // Set the clicked button
        $clickedButton.next().show();

        // Remove the error message
        $clickedButton.closest('div.datagrid-wrapper').find('.error-message').find('p').hide();

        var $form = $clickedButton.closest('div.datagrid-wrapper').find('form#access-edit');

        // Let's save the access for this user
        var url = $clickedButton.attr('href');
        //get the form values
        var formFields = $form.serialize();

        // Set the check boxes to disabled
        $form.find('input.has-access').attr('disabled','disabled').prop('disabled', true).next('label').addClass('disabled');

        // Save the access
        $.ajax(url, {
            method: "POST",
            cache: false,
            data: formFields,
            success : function(data){
                if(data.status == 1){
                    // Set the green color to the rows
                    $clickedButton.addClass($clickedButton.data('edit-class'));
                    $clickedButton.removeClass($clickedButton.data('save-class'));
                    $clickedButton.text($clickedButton.data('text-edit'));

                    // Set the text color to text-success
                    $form.find('.item-name').addClass('text-success').addClass('animate');

                    setTimeout(function(){
                        $form.find('.item-name').removeClass('text-success');
                    }, 1000);

                    // Update the inintial state of the checkboxes to the new one
                    $form.find('input.has-access').each(function(index, el){
                        if($(el).is(':checked')){
                            $(el).data('initial-value', "1").attr('data-initial-value', "1");
                        }
                        else{
                            $(el).data('initial-value', "0").attr('data-initial-value', "0");
                        }
                    });

                    $('*').trigger('access-saved');
                }
            },
            error : function(jqXHR){
                var data = jqXHR.responseJSON;
                $form.find('input.has-access').removeAttr('disabled').prop('disabled', false).next('label').addClass('disabled');
                // add the errors
                $cancelButton.show();
                // Set the error(s)
                if(data.errors.main_error){
                    $('*').trigger('access-failed');
                    errorField.find('.warning-text').text(data.errors.main_error);
                    errorField.show();
                }
            }
        }).always(function(){
            $clickedButton.next().hide();
        });
    }

    function cancelEditAccess($clickedButton, key){
        $clickedButton.text($clickedButton.data('text-edit'));
        $clickedButton.removeClass($clickedButton.data('save-class'));
        $clickedButton.addClass($clickedButton.data('edit-class'));

        // Set the checkboxes to undisabled
        var $form = $clickedButton.closest('div.datagrid-wrapper').find('form#access-edit');
        $form.find('input.has-access').attr('disabled', 'disabled').prop('disabled', true).next('label').addClass('disabled');
        $form.find('input.has-access').each(function(index, el){
            if ($(el).attr('data-initial-value')) {
                if ($(el).attr('data-initial-value') == "1") {
                    $(el).attr('checked', 'checked').prop('checked', true);
                } else {
                    $(el).removeAttr('checked').prop('checked', false);
                }
            }
        });

        // Remove the error message
        $clickedButton.closest('div.datagrid-wrapper').find('.error-message').find('p').hide();
    }

    function resetToInitial(){
        $(document).find('input.has-access').each(function(index, el){
            if ($(el).attr('data-initial-value')) {
                if ($(el).attr('data-initial-value') == "1") {
                    $(el).attr('checked', 'checked').prop('checked', true);
                } else {
                    $(el).removeAttr('checked').prop('checked', false);
                }
            }
        });
    }
    /**
     * Assign access - End
     */

    // Set the correct timefrmae
    function setTimeFrameOverview(type, edit){
        $(document).find('.timeframe_overview').addClass('d-none');
        $(document).find('.show_'+type).removeClass('d-none');
        $(document).find('div.date-selection').removeClass('d-none');
        let formName = $(document).find('div.date-selection').closest('form').attr('id');

        if(type === 'business_hours' || type === 'all_time_access'){
            // unset the end date
            // And set a checkmark at all day
            if(typeof edit != 'undefined' && edit === true) {
                $(document).find('form#' + formName +' input.end_date').val('');
                $(document).find('form#' + formName +' input.any_date').attr('checked', 'checked').prop('checked', true);
            }
        }
        else if(type === 'today'){
            const today = dayjs(new Date());
            const dateFormat = toUpper(document.querySelector('.datepicker.start_date').getAttribute('data-dateformat'));
            const todayFormatted = today.format(dateFormat);

            $(document).find('form#' + formName +' input.start_date').val(todayFormatted);
            $(document).find('form#' + formName +' input.end_date').val(todayFormatted);
            $(document).find('form#' + formName +' input.any_date').removeAttr('checked').prop('checked', false);
            $(document).find('div.date-selection').addClass('d-none');
        }
    }

    //user is "finished typing," do something
    function validateEmail () {
        // Show spinner
        var $emailInput = $('.create-user-flow form #email');
        var email =  $emailInput.val();
        var emailhidden = $('.create-user-flow form #emailhidden');
        var validated = $emailInput.data('validated');

        if(email.length != 0 && validated == 'false'
            && emailhidden != email) {
            // Show spinner
            $emailInput.parent().next().find('.spinner').show();
            $emailInput.next('.checkmail').hide();
            var url = $emailInput.data('validateurl');
            $('.create-user-flow form #emailhidden').val(email);

            var formFields = [];
            formFields.push({
                name: "_token",
                value: $(document).find('input[name="_token"]').val()
            });
            formFields.push({
                name: "email",
                value: email
            });

            $.ajax(url, {
                method: "POST",
                data: $.param(formFields),
                cache: false,
                success: function (data) {
                    $emailInput.removeClass('is-invalid')
                },
                error: function (jqXHR) {
                    // Set an error

                    //if(isset errors man) show the error
                    if (jqXHR.responseJSON) {
                        var data = jqXHR.responseJSON;
                        // Set the error
                        var error = data.error;
                        $emailInput.parent().addClass('is-invalid')
                        $emailInput.next().next().show().text(error);
                        return false;
                    }
                },
            }).always(function () {
                $emailInput.parent().next().find('.spinner').hide();
                $emailInput.next('.checkmail').hide();
            });
        }
        else if(validated === true){
            $(".create-user-flow .next-step").show();
        }
    }

    function restoreIq(){
        var url = $('#restore_iq_link').val();

        var formFields = [];
        // Remove the button of the page
        formFields.push({name: "_token", value: $(document).find('input[name="_token"]').val()});
        $.ajax(url, {
            method: "POST",
            data: $.param(formFields),
            success : function(data){
                if(data.status && data.status == 1){
                    $(document).find('.restore_message').html(data.message).show();
                    $(document).find('.spinning').hide();
                    $(document).find('.restore_iq_close_btn').show();
                }
            },
            error : function(jqXHR){
                //if(isset errors man) show the error
                var message = '';
                if (jqXHR.responseText) {
                    var data = $.parseJSON(jqXHR.responseText);
                    if (data.message) {
                        message = data.message;
                    }
                }

                // Set the message
                $(document).find('.restore_message').html(message).show();
                $(document).find('.spinning').hide();
                // Show the button to close the modal
                $(document).find('.restore_iq_close_btn').show();
            }
        });
    }

    function doInitialStatusCheck(){
        var iqs = [],
            repeaters = [],
            locks = [],
            tags = [],
            devices = [];

        // Get list of IQS to fetch data from all at once
        $('span[data-clp="status"][data-type="iq"]').each(function(index, el){
            iqs.push($(el).data('value'));
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.text-danger').remove();
            $(el).parent().find('.wifi-symbol').remove();
            $(el).parent().find('.status-button').each(function(index, el){
                setButtonLoadingState(el)
            });
        });

        // Get list of Repeaters to fetch data from all at once
        $('span[data-clp="status"][data-type="repeater"]').each(function(index, el){
            repeaters.push($(el).data('value'));
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(index, el){
                setButtonLoadingState(el)
            });
        });

        // Get list of Locks to fetch data from all at once
        $('span[data-clp="status"][data-type="lock"]').each(function(index, el){
            if(locks.indexOf($(el).data('value')) === -1) {
                locks.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(index, el){
                setButtonLoadingState(el);
            });
        });

        // Get list of Locks to fetch data from all at once
        $('span[data-clp="status"][data-type="tag"]').each(function(index, el){
            if(tags.indexOf($(el).data('value')) === -1) {
                tags.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(index, el){
                setButtonLoadingState(el);
            });
        });

        // Get list of devices to fetch data from all at once
        $('span[data-clp="status"][data-type="device"]').each(function(index, el){
            if(devices.indexOf($(el).data('value')) === -1) {
                devices.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(index, el){
                setButtonLoadingState(el);
            });
        });

        clp.getStatusFromClp(iqs, repeaters, locks, tags, devices);
    }

    var registeringTags = [];
    /**
     * Add the tagNumber to the array
     * @param tagNumber
     */
    function addRegisteringTags(tagNumber){
        // Add the number to the array
        registeringTags.push(tagNumber);
    }

    /**
     * Check if the tagNumber is in the array
     * @param tagNumber
     */
    function checkRegisteringTags(tagNumber){
        // Check if the number is in the array?
        if(registeringTags.indexOf(tagNumber) > -1){
            // If yes, do nothing.
            return true;
        }
        return false;
    }

    /**
     * Remove the tagNumber from the array
     * @param tagNumber
     */
    function removeRegisteringTags(tagNumber){
        // Remove the tag from the array
        var indexOf = registeringTags.indexOf(tagNumber);
        if(indexOf > -1){
            delete registeringTags[indexOf];
        }
    }

    function setButtonLoadingState(button) {
        if (button instanceof jQuery) {
            button = button.get(0);
        }
        if (!button.dataset.resetText) {
            button.dataset.resetText = button.innerText;
        }
        setTimeout(() => {
            button.innerText = button.dataset.loadingText || 'Loading...';
            button.classList.add('disabled');
            button.disabled = true;
        }, 0);
    }

    function setButtonLoadingStateForSelector(selector) {
        var buttons = document.querySelectorAll(selector);
        buttons.forEach(button => {
            setButtonLoadingState(button);
        });
    }

    function resetButtonLoadingState(button) {
        if (button instanceof jQuery) {
            button = button.get(0);
        }
        button.disabled = false;
        button.innerText = button.dataset.resetText || button.innerText;
        button.classList.remove('disabled');
    }

    function setButtonText(button, text) {
        if (!button) {
            return;
        }

        if (button instanceof jQuery) {
            if (button.length === 0) {
                return;
            }
            button = button.get(0);
        }

        const dataAttribute = `text-${text}`;
        button.innerText = button.dataset[dataAttribute] || text;

        return button;
    }

    async function refreshAccessMethodsOverview() {
        const accessMethodsOverview = document.getElementById('access-methods-overview');
        if (!accessMethodsOverview) {
            location.reload();
        }
        const refreshUrl = accessMethodsOverview?.dataset.refreshUrl;

        if (refreshUrl) {
            const refreshResponse = await fetch(refreshUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });
            const data = await refreshResponse.json();
            if (data.html) {
                accessMethodsOverview.innerHTML = data.html;
                const tooltipTriggerList = Array.from(accessMethodsOverview.querySelectorAll('[data-bs-toggle="tooltip"]'));
                initTooltips(tooltipTriggerList);
            }
        }
    }

    utils_hooks__hooks.version = '1.0.0';
    utils_hooks__hooks.closeSearch = closeSearch;
    utils_hooks__hooks.hideModals = hideModals;
    utils_hooks__hooks.showModal = showModal;
    utils_hooks__hooks.getModal = getModal;
    utils_hooks__hooks.postModal = postModal;
    utils_hooks__hooks.typeAhead = typeAhead;
    utils_hooks__hooks.searchEmployeetypeAhead = searchEmployeetypeAhead;
    utils_hooks__hooks.doReadOnly = doReadOnly;
    utils_hooks__hooks.doReadOnlyLocks = doReadOnlyLocks;
    utils_hooks__hooks.cloneRow = cloneRow;
    utils_hooks__hooks.registerItem = registerItem;
    utils_hooks__hooks.postRegisterItems = postRegisterItems;
    utils_hooks__hooks.addRepeaterToDropdown = addRepeaterToDropdown;
    utils_hooks__hooks.addRepeaterToDropdownNew = addRepeaterToDropdownNew;
    utils_hooks__hooks.checkForChangeOldata = checkForChangeOldata;
    utils_hooks__hooks.getSignalStrengthIcon = getSignalStrengthIcon;
    utils_hooks__hooks.placeErrorAfterItem = placeErrorAfterItem;
    utils_hooks__hooks.unsetErrorsClasses = unsetErrorsClasses;
    utils_hooks__hooks.setErrors = setErrors;
    utils_hooks__hooks.afterRegistration = afterRegistration;
    utils_hooks__hooks.checkForFilledTags = checkForFilledTags;
    utils_hooks__hooks.sendTree = sendTree;
    utils_hooks__hooks.getReleaseErrors = getReleaseErrors;
    utils_hooks__hooks.restoreIq = restoreIq;
    utils_hooks__hooks.registerTag = registerTag;
    utils_hooks__hooks.registerBatchTag = registerBatchTag;
    utils_hooks__hooks.unassignBatchTag = unassignBatchTag;
    utils_hooks__hooks.unAssignTag = unAssignTag;
    utils_hooks__hooks.editCompanyAccess = edit_company_access;
    utils_hooks__hooks.saveAccess = saveAccess;
    utils_hooks__hooks.cancelEditAccess = cancelEditAccess;
    utils_hooks__hooks.setTimeFrameOverview = setTimeFrameOverview;
    utils_hooks__hooks.validateEmail = validateEmail;
    utils_hooks__hooks.doInitialStatusCheck = doInitialStatusCheck;
    utils_hooks__hooks.resetToInitial = resetToInitial;
    utils_hooks__hooks.addRegisteringTags = addRegisteringTags;
    utils_hooks__hooks.checkRegisteringTags = checkRegisteringTags;
    utils_hooks__hooks.removeRegisteringTags = removeRegisteringTags;
    utils_hooks__hooks.setButtonLoadingState = setButtonLoadingState;
    utils_hooks__hooks.setButtonLoadingStateForSelector = setButtonLoadingStateForSelector;
    utils_hooks__hooks.setButtonText = setButtonText;
    utils_hooks__hooks.resetButtonLoadingState = resetButtonLoadingState;
    utils_hooks__hooks.refreshAccessMethodsOverview = refreshAccessMethodsOverview;

    return utils_hooks__hooks;
})();

export default customfn
